// extracted by mini-css-extract-plugin
export var bodySections = "_9h-8";
export var gray = "_9h-7";
export var green = "_9h-4";
export var iconContainer = "_9h-9";
export var iconWidgetContainer = "_9h-1";
export var phoneIcon = "_9h-2";
export var red = "_9h-5";
export var statusDot = "_9h-3";
export var widgetContainer = "_9h-0";
export var yellow = "_9h-6";